// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DragAndDrop_wrapper__Oht2x","messageZone":"DragAndDrop_messageZone__2M1W1","message":"DragAndDrop_message__sH1ju"};